"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var observable_1 = require("../symbol/observable");
function isInteropObservable(input) {
    return input && typeof input[observable_1.observable] === 'function';
}
exports.isInteropObservable = isInteropObservable;
//# sourceMappingURL=isInteropObservable.js.map


//////////////////
// WEBPACK FOOTER
// ./~/rxjs/internal/util/isInteropObservable.js
// module id = 2281
// module chunks = 0